module.exports = __webpack_public_path__ + "img/Home-CTSP.c9c24d59.png";